import React from 'react';
import NotYet from '../components/NotYet';

function NotFound(props) {
  return <NotYet title="This page doesn't exist" text="maybe head back to the homepage and try again!" />;
}

export default NotFound;
